import ContentCard from './ContentCard';
import ContentCardHorizontal from './ContentCardHorizontal';

export default Object.assign(ContentCard, {
    Horizontal: ContentCardHorizontal
});
